// Global Instructions Rule Applied!

import { InteractionsState, InteractionsAction } from '../../interfaces/interactions.ts'
import { interactionsState } from '../../store_models/interactions.ts'
import { InteractionRecordFields } from '../../data_models/interaction_record.ts'
import {
  SET_INTERACTIONS,
  UPDATE_INTERACTION,
  ADD_INTERACTION,
  REMOVE_INTERACTION,
  CLEAR_INTERACTIONS
} from './constants.ts'

const interactionsReducer = (
  state: InteractionsState = interactionsState,
  action: InteractionsAction
): InteractionsState => {
  switch (action.type) {
    case SET_INTERACTIONS: {
      const { entityId, interactions } = action.payload

      return {
        ...state,
        [entityId]: interactions
      }
    }

    case UPDATE_INTERACTION: {
      const { entityId, interactionId, updates } = action.payload
      const interactions = state[entityId] || []
      const idField = InteractionRecordFields.interactions__id

      return {
        ...state,
        [entityId]: interactions.map((interaction) => {
          const existingInteractionId = interaction[idField]
          // Compare as strings to handle UUID comparison reliably
          if (existingInteractionId?.toString() === interactionId?.toString()) {
            return { ...interaction, ...updates }
          }
          return interaction
        })
      }
    }

    case ADD_INTERACTION: {
      const { entityId, interaction } = action.payload
      const interactions = state[entityId] || []
      const idField = InteractionRecordFields.interactions__id
      const interactionId = interaction[idField]

      // Check if interaction already exists
      const exists = interactions.some((existing) => existing[idField] === interactionId)

      if (exists) {
        return state
      }

      return {
        ...state,
        [entityId]: [...interactions, interaction]
      }
    }

    case REMOVE_INTERACTION: {
      const { entityId, interactionId } = action.payload
      const interactions = state[entityId] || []
      const idField = InteractionRecordFields.interactions__id

      return {
        ...state,
        [entityId]: interactions.filter((interaction) => interaction[idField] !== interactionId)
      }
    }

    case CLEAR_INTERACTIONS: {
      const { entityId } = action.payload
      const newState = { ...state }
      delete newState[entityId]
      return newState
    }

    default:
      return state
  }
}

export default interactionsReducer
export * from './interaction_actions.ts'
export * from './selectors.ts'
